import MomentUtils from '@date-io/moment';
import { Moment } from 'moment';
import React, { useState } from 'react';
import { Theme, WithStyles, withStyles } from '@material-ui/core/styles';
import { DateTimePickerProps, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';

import { colors } from '../themes/colors';
import { textInputStyle } from '../themes/input';

export const TestID = 'MHDatePicker.TestID';

const styles = (theme: Theme) => ({
  ...textInputStyle(theme),
  selectContainer: {
    color: colors.gray18,
    fontSize: '14px',
    maxHeight: 40,
    fontFamily: 'Avenir-Medium',
    borderRadius: 6,
    '& input': {
      cursor: 'pointer',
    },
    '& fieldset': {
      borderColor: '#E9EEF4',
      borderWidth: 1,
    },
    '&:hover fieldset': {
      borderColor: `${colors.blue6} !important`,
    },
    '& .Mui-focused fieldset': {
      borderColor: `${colors.blue6} !important`,
    },
    '& div.Mui-error fieldset': {
      borderColor: '#e53e3e !important',
    },
    '& .MuiButtonBase-root.MuiIconButton-root': {
      outline: 'none',
      position: 'absolute',
      right: 0,
      marginTop: 2,
      color: colors.gray16,
    },
  },
  selectContainerOpen: {
    '& fieldset': {
      borderColor: `${colors.blue6} !important`,
      borderWidth: 2,
    },
  },
});

type Props = WithStyles & {
  value: Moment | null;
  onChange: (date: MaterialUiPickersDate) => void;
  Picker: React.FC<DateTimePickerProps>;
  format?: string;
  placeholder?: string;
  showError?: boolean;
  dataTestid?: string;
};

const MHDatePicker: React.FC<Props> = ({
  classes,
  dataTestid,
  Picker,
  value,
  format,
  placeholder,
  onChange,
  showError,
}) => {
  const [open, setOpen] = useState(false);

  return (
    <MuiPickersUtilsProvider utils={MomentUtils}>
      <>
        <Picker
          value={value}
          required
          open={open}
          onChange={onChange}
          inputVariant="outlined"
          margin="dense"
          placeholder={placeholder}
          format={format}
          InputProps={{
            readOnly: true,
            className: classes.selectContainer,
          }}
          className={`${classes.textField} ${classes.selectContainer} ${
            open && classes.selectContainerOpen
          }`}
          error={showError}
          onClick={() => setOpen(true)}
          onClose={() => setOpen(false)}
          inputProps={{
            'data-testid': dataTestid || TestID,
          }}
        />
        {showError ? (
          <p className="mt-1 font-xs text-red-600 font-medium">Select session date and time</p>
        ) : null}
      </>
    </MuiPickersUtilsProvider>
  );
};

export default withStyles(styles)(MHDatePicker);
